import { render, staticRenderFns } from "./payment-list-component.vue?vue&type=template&id=af3530fe&scoped=true"
import script from "./payment-list-component.vue?vue&type=script&lang=js"
export * from "./payment-list-component.vue?vue&type=script&lang=js"
import style0 from "./payment-list-component.vue?vue&type=style&index=0&id=af3530fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3530fe",
  null
  
)

export default component.exports